import { render, staticRenderFns } from "./MyCredits.vue?vue&type=template&id=779f504c&scoped=true&"
import script from "./MyCredits.vue?vue&type=script&lang=js&"
export * from "./MyCredits.vue?vue&type=script&lang=js&"
import style0 from "./MyCredits.vue?vue&type=style&index=0&id=779f504c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779f504c",
  null
  
)

export default component.exports